import React from 'react';
import { useSelector } from 'react-redux';
import { colors } from '../../constants/colors';
import { isForeignCityCar } from '../../utils/foreignCityCar';

/**
 * Город машины в списке стока. Если машина не из городов сотрудника — помечаем.
 *
 * Сток показывает только свои города, но поиск по полному VIN находит машину
 * откуда угодно: иначе её не перенести к себе. Раз машина нашлась, менеджер по
 * привычке считает её своей — отсюда отметка (24.10.2026, Тараз).
 */
export default function ForeignCityCell({ city }) {
  const userCities = useSelector((state) => state?.user?.cities);
  const foreign = isForeignCityCar(city?.id, userCities);

  if (!foreign) return <span>{city?.title ?? ''}</span>;

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', columnGap: '6px', flexWrap: 'wrap' }}>
      <span style={{ fontWeight: 600 }}>{city?.title ?? ''}</span>
      <span
        style={{
          backgroundColor: colors.orange,
          color: colors.white,
          borderRadius: '10px',
          padding: '1px 8px',
          fontSize: '11px',
          whiteSpace: 'nowrap',
        }}
        title="Машина стоит в другом городе. Чтобы работать с ней, смените город в карточке автомобиля."
      >
        другой город
      </span>
    </span>
  );
}
